var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"document-list-item-tags-list"},[_c('v-icon',[_vm._v("mdi-pound")]),_vm._v(" "),_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index,staticClass:"document-list-item-tag"},[_vm._v("\n    "+_vm._s(tag)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }